import React, { useEffect, useRef, useState } from "react";
import styles from "./ArtistAccount.module.scss";
import RadioInput from "components/radioInput/RadioInput";
import Dropdown from "components/dropdown/Dropdown";
import placeholderImage from "../../../assets/images/placeholder.png";
import uploadImage from "../../../assets/images/upload.png";
import SearchIcon from "components/svgs/SearchIcon";
import DeleteIcon from "components/svgs/DeleteIcon";
import {
  countryOptions,
  dayOptions,
  monthOptions,
  yearOptions,
} from "utils/DropdownOptions";
import CropImagePopup from "components/popups/CropImagePopup";

const ArtistAccount = () => {
  const portraitRef = useRef(null);
  const documentsRef = useRef(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    pseudonyme: "",
    nameToUse: "realname",
    dateOfBirth: {
      month: "",
      day: "",
      year: "",
    },
    selectedPortrait: null,
    biography: "",
    country: "",
    website: "",
    instagram: "",
    facebook: "",
    artistCategory: [],
    documents: [],
  });

  const [showPortraitCropPopup, setShowPortraitCropPopup] = useState(false);
  const [selectedCropImage, setSelectedCropImage] = useState(null);

  const handlePortraitDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0 && !formData.selectedPortrait) {
      setFormData({ ...formData, selectedPortrait: droppedFiles[0] });
    }
  };

  const handlePortraitChange = (event) => {
    if (event.target.files.length > 0 && !formData.selectedPortrait) {
      setFormData({ ...formData, selectedPortrait: event.target.files[0] });
    }
  };

  const handleDocumentsChange = (event) => {
    if (event.target.files.length > 0) {
      setFormData({
        ...formData,
        documents: [...formData.documents, event.target.files[0]],
      });
    }
  };

  const handleDocumentDelete = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  const handleSaveClick = async () => {
    console.log("formData", formData);
  };

  useEffect(() => {
    if (selectedCropImage) {
      if (selectedCropImage.type === "portrait") {
        setFormData({ ...formData, selectedPortrait: selectedCropImage.file });
      } else if (selectedCropImage.type === "document") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          documents: prevFormData.documents.map((doc, i) =>
            i === selectedCropImage.index ? selectedCropImage.file : doc
          ),
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCropImage]);

  useEffect(() => {
    console.log("formData", formData);
  }, [formData]);

  return (
    <div className={styles.createArtistAccountPage}>
      <div className={styles.form}>
        <div className={styles.formGroup}>
          <label></label>
          <h2 className={styles.formTitle}>Create Artist Account</h2>
        </div>
        <div className={styles.formGroup}>
          <label>First Name *</label>
          <input
            type="text"
            value={formData.firstName}
            onChange={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Last Name *</label>
          <input
            type="text"
            value={formData.lastName}
            onChange={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Pseudonyme</label>
          <input
            type="text"
            value={formData.pseudonyme}
            onChange={(e) =>
              setFormData({ ...formData, pseudonyme: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label></label>
          <div className={styles.radioGroup}>
            <RadioInput
              name="name"
              value="realname"
              label="Use My Real Name"
              isChecked={formData.nameToUse === "realname"}
              handleChange={(value) =>
                setFormData({ ...formData, nameToUse: value })
              }
            />
            <RadioInput
              name="name"
              value="pseudonyme"
              label="Use My Pseudonyme"
              isChecked={formData.nameToUse === "pseudonyme"}
              handleChange={(value) =>
                setFormData({ ...formData, nameToUse: value })
              }
            />
          </div>
        </div>
        <div className={styles.formGroup}>
          <label>Date of birth</label>
          <div className={styles.dropdownGroup}>
            <Dropdown
              placeholder="Month"
              options={monthOptions}
              selectedValue={formData.dateOfBirth.month}
              handleChange={(value) =>
                setFormData({
                  ...formData,
                  dateOfBirth: { ...formData.dateOfBirth, month: value },
                })
              }
            />
            <Dropdown
              placeholder="Day"
              options={dayOptions}
              selectedValue={formData.dateOfBirth.day}
              handleChange={(value) =>
                setFormData({
                  ...formData,
                  dateOfBirth: { ...formData.dateOfBirth, day: value },
                })
              }
            />
            <Dropdown
              placeholder="Year"
              options={yearOptions}
              selectedValue={formData.dateOfBirth.year}
              handleChange={(value) =>
                setFormData({
                  ...formData,
                  dateOfBirth: { ...formData.dateOfBirth, year: value },
                })
              }
            />
          </div>
        </div>
        <div className={styles.formGroup}>
          <label></label>
          <div className={styles.portraitContainer}>
            <h2>Your Portrait</h2>
            {!formData.selectedPortrait ? (
              <div
                className={styles.uploadFileContainer}
                onDrop={handlePortraitDrop}
                onDragOver={(event) => event.preventDefault()}
                onClick={() => portraitRef.current?.click()}
              >
                <img
                  className={styles.placeholderImage}
                  src={placeholderImage}
                  alt="placeholder"
                />
                <img
                  className={styles.uploadImage}
                  src={uploadImage}
                  alt="placeholder"
                />
                <div className={styles.uploadFileText}>Upload a file</div>
                <div className={styles.dragDropText}>
                  Drag and drop files here
                </div>
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept="image/*"
                  ref={portraitRef}
                  onChange={handlePortraitChange}
                />
              </div>
            ) : (
              <div className={styles.selectedPortraitContainer}>
                <div className={styles.selectedPortrait}>
                  <img
                    src={URL.createObjectURL(formData.selectedPortrait)}
                    alt={formData.selectedPortrait?.name}
                  />
                </div>
                <div className={styles.imageActions}>
                  <div
                    className={styles.cropImage}
                    onClick={() => {
                      setShowPortraitCropPopup(true);
                      setSelectedCropImage({
                        file: formData.selectedPortrait,
                        type: "portrait",
                      });
                    }}
                  >
                    <span>Crop</span>
                    <SearchIcon />
                  </div>
                  <div
                    className={styles.deleteImage}
                    onClick={() =>
                      setFormData({ ...formData, selectedPortrait: null })
                    }
                  >
                    <span>Delete</span>
                    <DeleteIcon />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label>
            Biography * <span>Max. 500 words</span>
          </label>
          <textarea
            placeholder="Type some text here"
            rows={7}
            value={formData.biography}
            onChange={(e) =>
              setFormData({ ...formData, biography: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Country *</label>
          <Dropdown
            placeholder="Choose a Country..."
            options={countryOptions}
            selectedValue={formData.country}
            handleChange={(value) =>
              setFormData({
                ...formData,
                country: value,
              })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Website</label>
          <input
            type="text"
            value={formData.website}
            onChange={(e) =>
              setFormData({ ...formData, website: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Instagram</label>
          <input
            type="text"
            value={formData.instagram}
            onChange={(e) =>
              setFormData({ ...formData, instagram: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Facebook</label>
          <input
            type="text"
            value={formData.facebook}
            onChange={(e) =>
              setFormData({ ...formData, facebook: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Artist Category *</label>
          <div className={styles.checkboxGroup}>
            <div className={styles.checkboxWrapper}>
              <input
                id="painter"
                type="checkbox"
                checked={formData.artistCategory.includes("painter")}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    artistCategory: prevFormData.artistCategory.includes(
                      "painter"
                    )
                      ? prevFormData.artistCategory.filter(
                          (category) => category !== "painter"
                        )
                      : [...prevFormData.artistCategory, "painter"],
                  }))
                }
                className={
                  formData.artistCategory.includes("painter")
                    ? styles.checked
                    : ""
                }
              />
              <label htmlFor="painter">Painter</label>
            </div>
            <div className={styles.checkboxWrapper}>
              <input
                id="sculptor"
                type="checkbox"
                checked={formData.artistCategory.includes("sculptor")}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    artistCategory: prevFormData.artistCategory.includes(
                      "sculptor"
                    )
                      ? prevFormData.artistCategory.filter(
                          (category) => category !== "sculptor"
                        )
                      : [...prevFormData.artistCategory, "sculptor"],
                  }))
                }
                className={
                  formData.artistCategory.includes("sculptor")
                    ? styles.checked
                    : ""
                }
              />
              <label htmlFor="sculptor">Sculptor</label>
            </div>
          </div>
        </div>
        <div className={styles.formGroup}>
          <label>Documents *</label>
          <div className={styles.documentsContainer}>
            {formData.documents.length ? (
              <div className={styles.selectedDocumentsGrid}>
                {formData.documents.map((document, index) => {
                  return (
                    <div
                      key={index + document.name}
                      className={styles.selectedDocumentContainer}
                    >
                      <div className={styles.selectedDocument}>
                        <img
                          src={URL.createObjectURL(document)}
                          alt={document.name}
                        />
                      </div>
                      <div className={styles.imageActions}>
                        <div
                          className={styles.cropImage}
                          onClick={() => {
                            setShowPortraitCropPopup(true);
                            setSelectedCropImage({
                              file: document,
                              type: "document",
                              index,
                            });
                          }}
                        >
                          <span>Crop</span>
                          <SearchIcon />
                        </div>
                        <div
                          className={styles.deleteImage}
                          onClick={() => handleDocumentDelete(index)}
                        >
                          <span>Delete</span>
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            {formData.documents.length < 2 ? (
              <>
                <div
                  className={styles.uploadFileContainer}
                  onClick={() => documentsRef.current?.click()}
                >
                  <img
                    className={styles.uploadImage}
                    src={uploadImage}
                    alt="placeholder"
                  />
                  <div className={styles.uploadFileText}>Upload a file</div>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept="image/*"
                    ref={documentsRef}
                    onChange={handleDocumentsChange}
                  />
                </div>
                <p className={styles.helperText}>
                  Please upload documents to verify your identity
                </p>
              </>
            ) : null}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label></label>
          <div className={styles.saveBtnContainer}>
            <button onClick={handleSaveClick}>Save Information</button>
          </div>
        </div>
      </div>
      {showPortraitCropPopup ? (
        <CropImagePopup
          showPopup={showPortraitCropPopup}
          setShowPopup={setShowPortraitCropPopup}
          selectedImage={selectedCropImage}
          setSelectedImage={setSelectedCropImage}
        />
      ) : null}
    </div>
  );
};

export default ArtistAccount;
